import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import Mainlayout from "../../components/Mainlayout";
import Productlist from "../productList/Productlist";
import { compareState } from "../../store/CompareState";
import { useRecoilState } from "recoil";
import MyButton from "../../components/button/MyButton";

const ComparePage = styled.div`
  padding: 20px;
  // font-family: Arial, sans-serif;

  @media (max-width: 768px) {
    padding: 10px;
  }
`;

const Heading = styled.h1`
  text-align: center;
  margin-bottom: 20px;
  font-size: 1.8rem;
  color: #333;

  @media (max-width: 768px) {
    font-size: 1.4rem;
  }
`;

const CompareTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;

  @media (max-width: 768px) {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
`;

const TableRow = styled.tr`
border: 1px solid #ddd;
  &:first-child td {
    border: 1px solid #ddd;
    text-align: center;
    font-weight: bold;
    color: #555;
    font-size: 1.3rem;

    @media (max-width: 768px) {
      font-size: 1rem;
    }
  }

  &:not(:first-child) td {
    border: 1px solid #ddd;
    text-align: left;
    padding: 10px 15px;
    font-size: 1.1rem;

    @media (max-width: 768px) {
      font-size: 0.9rem;
      padding: 8px 10px;
    }
  }

  &:nth-child(even):not(:first-child) {
    background-color: #f9f9f9;
  }

  &:nth-child(odd):not(:first-child) {
    background-color: #ffffff;
  }
`;

const TableCell = styled.td`
  padding: 10px 15px;

  &:first-child {
    width: 400px; /* Adjust the width as needed */

    @media (max-width: 768px) {
      width: 200px;
    }
  }

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 8px 10px;
  }
`;

const ProductImage = styled.div`
  img {
    width: 150px;
    height: 150px;
    object-fit: cover;
    border-radius: 4px;
    margin-bottom: 5px;

    @media (max-width: 768px) {
      width: 100px;
      height: 100px;
    }
  }
`;

const ProductIdName = styled.p`
  display: flex;
  align-items: start;
  font-size: 15px;

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

const RemoveButton = styled.button`
  background-color: ${window.ENV.GENERAL.BACKGROUND_COLOR};
  color: ${window.ENV.GENERAL.TEXT_COLOR};
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    color:white;
  }

  @media (max-width: 768px) {
    font-size: 13px;
    padding: 6px 12px;
  }
`;

const Compare = () => {
  const location = useLocation();
  const { itemName } = location.state || {};
  const [compareProducts, setCompareProducts] = useRecoilState(compareState);
  console.log("compareProducts", compareProducts);
  const removeProduct = (productId) => {
    const updatedProducts = compareProducts.filter((product) => product.productId !== productId);
    setCompareProducts(updatedProducts);
    console.log(updatedProducts);
  };

  const productCount = compareProducts.length;
  console.log("compareProducts", compareProducts);

  return (
    <Mainlayout categoryName={itemName}>
      <ComparePage>
        {compareProducts && compareProducts.length > 0 ? (
          <CompareTable>
            <tbody>
              <TableRow>
                <TableCell>
                  Comparing {productCount} {productCount === 1 ? 'Product' : 'Products'}
                </TableCell>

                {compareProducts.map((product, index) => (
                  <TableCell key={index}>
                    <ProductImage>
                      <img src={`${window.ENV.SERVER_URL}${product.isometric_view}`} alt={product.productId} />
                    </ProductImage>
                    <ProductIdName>{product.productId}</ProductIdName>
                  </TableCell>
                ))}
              </TableRow>
              {(() => {
                const firstProduct = compareProducts[0];
                if (!firstProduct) return null;

                const filteredItems = window.ENV.PRODUCT_LIST_ITEMS
                  .map((item) => ({ 
                    label: item.LABEL, 
                    value: firstProduct[item.VALUE],
                    key: item.VALUE
                  }))
                  .filter(({ value }) => 
                    value !== null && 
                    value !== undefined && 
                    value !== "" && 
                    value !== 'null' && 
                    value !== 'undefined'
                  );

                return filteredItems.map(field => (
                  <TableRow key={field.key}>
                    <TableCell>{field.label}</TableCell>
                    {compareProducts.map((product, index) => {
                      const value = product[field.key];
                      return (
                        <TableCell key={index}>
                          {value && value !== '' && value !== 'null' && value !== 'undefined' ? value : 'N/A'}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ));
              })()}
              <TableRow>
                <TableCell></TableCell>
                {compareProducts.map((product, index) => (
                  <TableCell key={index} style={{ textAlign: 'left', verticalAlign: 'middle' }}>
                    <MyButton onClick={() => removeProduct(product.productId)} name="Remove" />
                  </TableCell>
                ))}
              </TableRow>
            </tbody>
          </CompareTable>
        ) : (
          <p>No products selected for comparison.</p>
        )}
      </ComparePage>
    </Mainlayout>
  );
};

export default Compare;
